module.exports = __webpack_public_path__ + "static/media/information_project.4e8977d0.png";